import { getAccountBill } from "../../../api/services";
import { useQuery } from "react-query";

export const useAccountBill = (accountNumber: string, billNumber: string) => {
  return useQuery(
    ["accounts/bills", { accountNumber, billNumber }],
    getAccountBill,
    {
      enabled: !!accountNumber && !!billNumber,
    },
  );
};
